import { editableStoredPaymentScheduleSchema } from '@payaca/helpers/editableStoredPaymentSchedule';
import { z } from 'zod/v4';

/**
 * Form shape the payment schedule editor registers its fields against. Host
 * forms must nest an editable schedule under the `paymentSchedule` key and
 * resolve with this schema.
 */
export const PAYMENT_SCHEDULE_FORM_SCHEMA = z.object({
  paymentSchedule: editableStoredPaymentScheduleSchema,
});

export type PaymentScheduleFormValues = z.infer<
  typeof PAYMENT_SCHEDULE_FORM_SCHEMA
>;

export type ProposalStageCardProps = {
  index: number;
  /** Proposal total in minor units, inc tax. */
  proposalTotal: number;
  /** This stage's share of the total in minor units, inc tax. */
  amount: number;
  /** How much of this stage a fixed deposit pays, in minor units. */
  amountCoveredByDeposit?: number;
  remainingPercentage: number;
  /** Only the first stage can be the deposit. Omit on every other stage. */
  onDepositChange?: (isDeposit: boolean) => void;
  onRemove: () => void;
};

export type ProposalTemplateStageCardProps = Omit<
  ProposalStageCardProps,
  'proposalTotal' | 'amount' | 'amountCoveredByDeposit'
>;
